export const PAGE_SIZE_DEFAULT = 10;

export const PAGE_SIZE_OPTIONS = [10, 50, 100];
